import React from 'react'
import css from './patientCard.css'
import PatientPhones from './Phones'
import PatientAddress from './Address'
import ContactField from './ContactField'

const ContactInfo = ({
  id,
  loadPatientWithRelations,
  patient,
  hasRemindersTier2,
  countryCode,
  locationName,
}) => (
  <div className={css.contactInfo}>
    <div className={css.contactItem}>
      <span className={css.label}>Practice Location</span>
      <span className={css.value}>{locationName}</span>
    </div>
    <PatientPhones patient={patient} countryCode={countryCode} />
    <div className={css.contactItem}>
      <span className={css.label}>Reminders Email</span>
      <span className={css.value}>{patient.reminders_email}</span>
    </div>
    <PatientAddress patient={patient} />
    <div>
      <ContactField fieldToUpdate="preferred_name" patient={patient} />
      <ContactField
        id={id}
        loadPatientWithRelations={loadPatientWithRelations}
        fieldToUpdate="preferred_phone"
        patient={patient}
      />
      <ContactField
        id={id}
        loadPatientWithRelations={loadPatientWithRelations}
        fieldToUpdate="preferred_email"
        patient={patient}
      />
      <ContactField
        fieldToUpdate="second_reminders_phone"
        patient={patient}
        requiresTier2
        hasRemindersTier2={hasRemindersTier2}
      />
      <ContactField
        fieldToUpdate="second_reminders_email"
        patient={patient}
        requiresTier2
        hasRemindersTier2={hasRemindersTier2}
      />
    </div>
  </div>
)

export default ContactInfo



// WEBPACK FOOTER //
// ./src/components/PatientPage/PatientCard/ContactInfo.js